import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  makeStyles,
  Tooltip,
  Button,
  Grid,
  Typography,
  DialogTitle,
  Divider,
  TextField,
  FormControl,
  Paper,
  Box,
  IconButton,
  FormControlLabel,
  FormLabel,
  InputLabel,
  Select,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import { useDispatch, useSelector } from "react-redux";
import {updateWeeklyInspection, submitWeeklyInspection, getInspectionsByUser, getFleetByLocation, getInspection} from "../../../actions/vehicleAction"
import {getLocations, getUsers} from "../../../actions/usersAction";
import Feedback from "../../../utils/Feedback";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },

  title: {
    fontSize: 13,
  },
  title2: {
    fontSize: 13,
    marginBottom: 10,
    fontWeight: "bold",

    },

  time: {
    // marginLeft: "auto",
    marginTop: 10,

    // width: 120,
    width: "fit-content",
    height: 40,
    padding: theme.spacing(1),
    // textAlign: "center",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    marginRight: 5,
  },
  btn: {
    padding: theme.spacing(1.5),
    marginTop: 30,
    marginBottom: 30,
    width: 300,
    [theme.breakpoints.down("sm")]: {
        width: "50%",
      },
    [theme.breakpoints.down("xs")]: {
    width: "100%",
    }
  },

  btn2:{
    marginBottom: 30,
    marginLeft: 10
  },
  dialog: {
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "100%",
    },
  },
  formControl: {
      minWidth: 400,
      [theme.breakpoints.down("sm")]: {
        minWidth: 330,
      },
      [theme.breakpoints.down("xs")]: {
          minWidth: "100%",
      }
  },
  formcontrol2: {
    textAlign: "left",
    minWidth: 400,
    [theme.breakpoints.down("sm")]: {
      minWidth: 330,
    },
    [theme.breakpoints.down("xs")]: {
        minWidth: "100%",
    }

  },

  paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
  },
  [theme.breakpoints.down("sm")]: {
      width: "100%",
  },
  [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
  },
  fab: {
      right: theme.spacing(-1),
  },
  tab: {
    marginTop: 10,
    marginBottom: 10,
    [theme.breakpoints.down("sm")]: {
      display:"block",
      lineHeight: 1.5,
    }
  },

  tabPanel: {
    width: 300,
    marginTop: 30,
    marginBottom: 30,
  },
  typo : {
    fontWeight: "bold",
    fontSize: 13,
  },

}));

const INIT_STATE = {
    inspector: "",
    supervisor: undefined,
    vehicle: "",
    date: "",
    location: undefined,
    mileage: "",
    tireGuage: "",
    engineOil: "",
    transmissionOil: "",
    coolantLevel: "",
    washerFluid: "",
    brakeFluid: "",
    beltCondition: "",
    brakes: "",
    registration: "",
    fuel: "",
    comment: "",   
    nextService: ""
};

const EditWeeklyInspectionModal = ({ openEditWeeklyInspection, handleCloseEditWeeklyInspection, id }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [state, setState] = useState(INIT_STATE);
  const [feed, setFeed] = React.useState({
    loading: false,
    open: false,
    message: "",
    success: false,
  });

  const { inspection, error, loading, locFleets } = useSelector((state) => state.vehicle);
  const { profile, locations, users} = useSelector((state) => state.users);

  useEffect(() => {
    dispatch(getInspectionsByUser());
    dispatch(getLocations());
    dispatch(getUsers());
    }, [dispatch]);

  useEffect(() => {
    dispatch(getFleetByLocation(profile.location?._id));
  }, [profile, dispatch]);

  useEffect(() => {
    const abortController = new AbortController();
    if (error && error !== null) {
      setFeed((prev) => ({
        loading: false,
        open: true,
        message: error,
        success: false,
      }));
    }
    return () => {
      abortController.abort();
    };
  }, [error]);

  useEffect(() => {
    if (id){
      dispatch(getInspection(id));
    }
    
  }, [dispatch, id]);
 
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      inspector: inspection && inspection.inspector,
      supervisor: inspection && inspection.supervisor,
      vehicle: inspection && inspection.vehicle,
      date: inspection && inspection.date,
      location: inspection && inspection.location._id,
      mileage: inspection && inspection.mileage,
      tireGuage: inspection && inspection.tireGuage,
      engineOil: inspection && inspection.engineOil,
      transmissionOil: inspection && inspection.transmissionOil,
      coolantLevel: inspection && inspection.coolantLevel,
      washerFluid: inspection && inspection.washerFluid,
      brakeFluid: inspection && inspection.brakeFluid,
      beltCondition: inspection && inspection.beltCondition,
      brakes: inspection && inspection.brakes,
      registration: inspection && inspection.registration,
      fuel: inspection && inspection.fuel,
      comment: inspection && inspection.comment,   
      nextService: inspection && inspection.nextService

    }));
  }, [inspection]);

  const handleChange = (e) => {
    e.persist();
    setState((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    
  };

  const handleSave = async (e) => {
    e.preventDefault();
    let data = {
        vehicle: state.vehicle,
        inspector: state.inspector,
        supervisor: state.supervisor,
        date: state.date,
        location: state.location,
        mileage: state.mileage,
        tireGuage: state.tireGuage,
        engineOil: state.engineOil,
        transmissionOil: state.transmissionOil,
        coolantLevel: state.coolantLevel,
        washerFluid: state.washerFluid,
        brakeFluid: state.brakeFluid,
        beltCondition: state.beltCondition,
        brakes: state.brakes,
        registration: state.registration,
        comment: state.comment,
        fuel: state.fuel,
        nextService: state.nextService,
        id
    };
    try {
      await dispatch(updateWeeklyInspection(data));
      handleCloseEditWeeklyInspection();
      dispatch(getInspectionsByUser());
      setFeed((prev) => ({
        loading: false,
        open: true,
        message: "Inspection Saved Successfully.",
        success: true,
      }));
    } catch (err) {
      setFeed((prev) => ({
        ...prev,
        loading: false,
        open: true,
        message: err.message || "Failed to save inspection.",
        success: false,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let data = {
        vehicle: state.vehicle,
        inspector: state.inspector,
        supervisor: state.supervisor,
        date: state.date,
        location: state.location,
        mileage: state.mileage,
        tireGuage: state.tireGuage,
        engineOil: state.engineOil,
        transmissionOil: state.transmissionOil,
        coolantLevel: state.coolantLevel,
        washerFluid: state.washerFluid,
        brakeFluid: state.brakeFluid,
        beltCondition: state.beltCondition,
        brakes: state.brakes,
        registration: state.registration,
        comment: state.comment,
        fuel: state.fuel,
        nextService: state.nextService,
        path: "vehicle/inspection/weekly",
        id
    };
    try {
      await dispatch(submitWeeklyInspection(data));
      handleCloseEditWeeklyInspection()
        dispatch(getInspectionsByUser());
        setFeed((prev) => ({
          loading: false,
          open: true,
          message: "Inspection Submitted Successfully.",
          success: true,
        }));
    } catch (err) {
      setFeed((prev) => ({
        ...prev,
        loading: false,
        open: true,
        message: err.message || "Failed to submit inspection.",
        success: false,
      }));
    }
  };

  const handleCloseFeed = () => {
    setFeed((prevState) => ({ ...prevState, open: false }));
  };

  const isValid = () =>
    !state.vehicle || !state.location

  return (
    <div>
      {feed.success ? (
        <Feedback
          handleCloseFeed={handleCloseFeed}
          open={feed.open}
          severity="success"
          message={feed.message}
        />
      ) : (
        <Feedback
          handleCloseFeed={handleCloseFeed}
          open={feed.open}
          severity="error"
          message={feed.message}
        />
      )}
      <Dialog
        open={openEditWeeklyInspection}
        onClose={handleCloseEditWeeklyInspection}
        fullWidth
        maxWidth="md"
        className={classes.dialog}

      >
        <DialogTitle>
        
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="overline" className={classes.title}>
                Edit Weekly Inspection
              </Typography>
            </Grid>
            <Grid item>
              <Tooltip arrow title="Close">
                <IconButton onClick={handleCloseEditWeeklyInspection}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </DialogTitle>
        <Divider />
        
        <DialogContent className={classes.dialogContent}>
          <Paper className={classes.paper} variant="outlined">
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <form onSubmit={handleSubmit}>
            
            <Grid container justifyContent="center" alignItems="center" spacing={3}>
            <Grid item xs={12} sm={6}>
                  <TextField
                      name="inspector"
                      fullWidth
                      variant="outlined"
                      label="Inspector"
                      value={state.inspector || ""}
                      onChange={handleChange}
                      required
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl className={classes.formControl}>
                        <Autocomplete 
                            id="supervisor"
                            options={users}
                            getOptionSelected={(option, value) => option.displayname === state.supervisor?.displayname}
                            getOptionLabel={(option) => option.displayname || ''} 
                            onChange={(e, value) => setState((prevState) => ({ ...prevState, supervisor: value }))}
                            value={state.supervisor || ''}
                            renderInput={(params) => 
                            <TextField {...params} variant="outlined" label="Supervisor" />} 
                        />
                    </FormControl>
                    
                </Grid>
                <Grid item xs={12} sm={6}>
                <FormControl className={classes.formControl}>
                    <Autocomplete 
                        id="vehicle"
                        options={locFleets}
                        getOptionSelected={(option) => option.diaplaname === state.vehicle?.displayname}
                        getOptionLabel={(option) => option.displayname || ''} 
                        onChange={(e, value) => {
                          e.persist();
                          setState((prevState) => (
                            { ...prevState, vehicle: value }))
                        }}
                        value={state.vehicle || ''}
                        renderInput={(params) => 
                        <TextField {...params} variant="outlined" label="Vehicle" required/>}       
                    />
                </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                <TextField
                    name="date"
                    fullWidth
                    variant="outlined"
                    label="Date"
                    onChange={handleChange}
                    value={state.date?.split("T")[0] || ''}
                    required
                    type="date"   
                />
                </Grid>

                <Grid item xs={12} sm={6} >
                  <FormControl variant="outlined" className={classes.formcontrol2}>
                    <InputLabel id="demo-simple-select-outlined-label">
                    Location
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      fullWidth
                      value={state.location || ""}
                      name="location"
                      onChange={handleChange}
                      label="Location"
                      required
                    >
                      <MenuItem value={null}>
                        <em>None</em>
                      </MenuItem>
                      {locations &&
                        locations.map((location) => (
                          <MenuItem key={location._id} value={location._id}>
                            {location.displayname}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                <TextField
                    name="mileage"
                    fullWidth
                    variant="outlined"
                    label="Mileage"
                    onChange={handleChange}
                    value={state.mileage}
                />
                </Grid>

                <Grid item xs={12} sm={6}>
                <FormControl variant="outlined" className={classes.formcontrol2}>
                    <InputLabel id="demo-simple-select-outlined-label">
                        Fuel Level
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        fullWidth
                        value={state.fuel || ""}
                        name="fuel"
                        onChange={handleChange}
                        label="Fuel Level"
                        variant="outlined"
                    >
                        <MenuItem value="Empty">Empty</MenuItem>
                        <MenuItem value="1/4">1/4</MenuItem>
                        <MenuItem value="1/2">1/2</MenuItem>
                        <MenuItem value="3/4">3/4</MenuItem>
                        <MenuItem value="Full">Full</MenuItem>
                    </Select>
                </FormControl>
              </Grid>
              
              <Grid item xs={12} sm={12}>
              <Typography variant="body2" gutterBottom color="primary">
                  1 - Ok;
                  2 - Requires Scheduled Maintenance;
                  3 - Requires Immediate Fix
                </Typography>
                </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Tire Guage</FormLabel>
                  <RadioGroup row name="tireGuage" value={state.tireGuage || ""} onChange={handleChange}>
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" />
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" />
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Engine Oil Level</FormLabel>
                  <RadioGroup row name="engineOil" value={state.engineOil || ""} onChange={handleChange}>
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1"/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2"/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3"/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Transmission Oil Level</FormLabel>
                  <RadioGroup row name="transmissionOil" value={state.transmissionOil || ""} onChange={handleChange}>
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1"/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2"/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3"/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Coolant Level</FormLabel>
                  <RadioGroup row name="coolantLevel" value={state.coolantLevel || ""} onChange={handleChange}>
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1"/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2"/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3"/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Washer Fluid Level</FormLabel>
                  <RadioGroup row name="washerFluid" value={state.washerFluid || ""} onChange={handleChange}>
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1"/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2"/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3"/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Brake Fluid Level</FormLabel>
                  <RadioGroup row name="brakeFluid" value={state.brakeFluid || ""} onChange={handleChange}>
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1"/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2"/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3"/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Belt Condition and Tension</FormLabel>
                  <RadioGroup row name="beltCondition" value={state.beltCondition || ""} onChange={handleChange}>
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1"/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2"/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3"/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Brakes and Park Brakes</FormLabel>
                  <RadioGroup row name="brakes" value={state.brakes || ""} onChange={handleChange}>
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1"/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2"/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3"/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Vehicle Registration and Insurance</FormLabel>
                  <RadioGroup row name="registration" value={state.registration || ""} onChange={handleChange}>
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1"/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2"/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3"/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              
              <Grid item xs={12} sm={6}>
              <TextField
                    name="nextService"
                    fullWidth
                    variant="outlined"
                    label=" Next Service Due Date"
                    onChange={handleChange}
                    value={state.nextService?.split("T")[0] || ''}
                    type="date"     
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                  <TextField
                  name="comment"
                  fullWidth
                  variant="outlined"
                  label="Comments/Rapairs Required"
                  onChange={handleChange}
                  multiline
                  value={state.comment || ""}
                  />
              </Grid>         
                                
            </Grid>
            <br /> 
          
            <Typography align="center">
                <Button
                  variant="contained"
                  size="large"
                  onClick={handleSave}
                  className={classes.btn2}
                  disabled={isValid() || loading}
                >
                  {loading ? "Loading..." : "Save"}
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  type="submit"
                  className={classes.btn2}
                  disabled={isValid() || loading}
                >
                  {loading ? "Loading..." : "Save & Submit"}
                </Button>
              </Typography>
            </form>              
          </Box>
          </Paper>

        </DialogContent>
      </Dialog>
    </div>
  );
};

export default EditWeeklyInspectionModal;
